import { Outlet } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <div className=" w-[100vw] h-screen">
    <Outlet />
    </div>
  );
}

export default App;
